import { fg } from '@confluence/feature-gating';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const FullPageEditorLoader: LoadableType<any> = LoadablePaint({
	name: MustPreloadLoadableNames.FullPageEditorLoader,
	loader: async () => {
		// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
		if (!fg('rovo_chat_fix_confluence_chunk_loading')) {
			const { FullPageEditorComponent } = await import(
				/* webpackChunkName: "loadable-FullPageEditorComponent" */ './FullPageEditorComponent.tsx'
			);
			return FullPageEditorComponent;
		}

		// Fetch the outer editor chunk AND the AI-mate @atlassian/conversation-
		// assistant chunk in parallel. Both `import()` calls live inside this
		// LoadablePaint object expression, so LoadableMetaBabelPlugin tags them
		// BOTH with this loadable's id — which causes parcel-reporter-loadable
		// to union both bundle groups into preloadAssets for this loadable.
		// Without the second `import()`, the register chunk that owns modules
		// like platform/…/atlassian-project-status-update-action-renderer/main.tsx
		// (module id 'iuVKP' on CDN / '2xPvv' locally) is not in this
		// loadable's chunk set, and the runtime throws
		//   `Cannot find module 'iuVKP'`
		// when FullPageEditorComponent's compiled
		//   `.then(() => parcelRequire('iuVKP'))` fires.
		const [outer] = await Promise.all([
			import(
				/* webpackChunkName: "loadable-FullPageEditorComponent" */ './FullPageEditorComponent.tsx'
			),
			// eslint-disable-next-line import/dynamic-import-chunkname
			import(
				/* webpackChunkName: "@atlassian/conversation-assistant" */
				'@atlassian/conversation-assistant/import-conversation-assistant'
			),
		]);
		return outer.FullPageEditorComponent;
	},
});
